// extracted by mini-css-extract-plugin
export var externalLink = "_ci-0";
export var internalLinkLabel = "_ci-1";